import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMenu",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--menu"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Menu",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 6a.5.5 0 0 1 .5-.5h8a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Zm0-3a.5.5 0 0 1 .5-.5h8a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Zm0 6a.5.5 0 0 1 .5-.5h8a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ s(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=menu.js.map
